<template>
  <div class="signupbgclr">
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
      v-model="snackbar" timeout="3000" :value="true" :color="snackbarclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <v-container fill-height class="SsoView">
      <v-card max-width="400px" class="mx-auto my-auto py-8 pb-1 rounded-xl text-center cards">
        <p class="font-weight-bold display-1 mb-0 black--text">Admin</p>

        <div class="px-4 px-sm-6 px-md-8">
          <img src="@/assets/BD.svg" width="70%" />
          <v-card-subtitle class="body-1"> </v-card-subtitle>
          <p class="title pb-6">Sign in your account using with Google</p>
          <v-btn v-if="emailids == null" @click="googleSignIn()" block large class="btn white rounded-lg"><img
              class="pa-2" src="@/assets/google.svg" /><span class="text-none"><b>Sign in with Google</b></span></v-btn>

          <v-btn v-else @click="exciTing()" block large class="btn white rounded-lg">
            <img class="pa-2" src="@/assets/google.svg" /><span class="text-none"><b>Sign in as {{ dspname }}</b> <br />
              <span class="activemailsty caption">{{ emailids }} <v-icon class="activhovsty" @click="removeData"
                  size="16">mdi-close</v-icon></span></span></v-btn>
          <v-card-subtitle style="font-size: 11px" class="text-center mb-3">
            <p style="color: #858b95" class="mt-8">
              By continuing with Google, you agree our Terms and<br />
              Privacy Policy.
            </p>
          </v-card-subtitle>
        </div>
      </v-card>
      <v-dialog persistent v-model="branchdialog" class="elevation-0" max-width="400px">
        <v-card style="overflow: hidden" class="elevation-0 rounded-lg">
          <v-row class="pl-4 pr-2 py-2">
            <v-col cols="10">
              <v-list-item-title class="font-weight-bold pb-4">Enter your Client code</v-list-item-title>
            </v-col>
            <v-col cols="2" class="text-right pt-2">
              <v-btn tile icon @click="closeDialog()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" width="17" height="17" fill="currentColor">
                  <path d="m.58 1.42.82-.82 15 15-.82.82z"></path>
                  <path d="m.58 15.58 15-15 .82.82-15 15z"></path>
                </svg>
              </v-btn>
            </v-col>
          </v-row>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="suBmit()">
            <div class="px-4">
              <v-text-field color="#3B82F6" label="Email" disabled v-model="email" dense outlined></v-text-field>
              <v-text-field color="#3B82F6" label="Employee code" required
                oninput="this.value = this.value.toUpperCase()" ref="uid"
                :rules="[(v) => !!v || 'Employee code is required']" v-model="empcode" dense outlined></v-text-field>
              <v-switch v-model="board" inset class="mt-0">
                <template #label>
                  <span class="font-weight-bold">{{ board ? "Rekyc Dashboard" : "Ekyc Dashboard" }}</span>
                </template></v-switch>
            </div>
            <v-row no-glutters class="px-4 pb-4">
              <v-col>
                <v-btn @click="closeDialog()" color="#ECEFF1" class="btnout mb-1 rounded-md elevation-0" block>
                  <span class="font-weight-bold black--text text-capitalize"> cancel </span>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn type="submit" :disabled="subbtn" :loading="subbtn" color="#3B82F6"
                  class="btnout mb-1 rounded-md elevation-0" block>
                  <span class="font-weight-bold white--text text-capitalize">Submit</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

import { sessapi } from "../api.js";

export default {
  data() {
    return {
      snackbar: false,
      snackbarclr: "default",
      snackmsgbar: "",

      valid: true,
      empcode: null,
      mobile: null,
      email: null,
      emailids: null,
      branchdialog: false,
      dspname: null,
      subbtn: false,
      board: false,

      stapilist: [],
    };
  },

  created() {
    document.title = "OA-Mynt dashboard";
    this.emailids = localStorage.getItem("email");
    this.dspname = localStorage.getItem("name");

    if (this.emailids != null) {
      // this.$router.push("/dashboard");
    } else {
      localStorage.clear();
    }
    this.subbtn = false;
  },
  mounted() {
    this.empcode = localStorage.getItem("empcode");
    this.getStraipList();
  },

  methods: {
    googleSignIn() {
      const provider = new GoogleAuthProvider();
      provider.addScope("profile");
      provider.addScope("email");

      provider.setCustomParameters({
        prompt: "select_account",
      });
      signInWithPopup(getAuth(), provider)
        .then((result) => {
          // console.log("Logged In", result);
          // console.log("this.stapilist", this.stapilist);
          // console.log("result.user.email", result.user.email);


          localStorage.clear();
          // console.log("this.stapilist", this.stapilist, this.getemailInList(result.user.email, "emailId"));
          // console.log("fun outtt");

          if (result.user.email.split("@")[1] == "zebuetrade.com" || (this.stapilist && this.getemailInList(result.user.email, "emailId"))) {
            // console.log("fun innnn");

            localStorage.setItem("name", result.user.displayName);
            localStorage.setItem("email", result.user.email);
            this.email = result.user.email;
            this.branchdialog = true;
            setTimeout(() => this.$refs.uid.$refs.input.focus(), 100);
            this.subbtn = false;
          } else {
            this.snackbar = true;
            this.snackbarclr = "#f23645";
            this.snackmsgbar = "invalid email address";
          }
        })
        .catch(function (error) {
          console.log(error);
          console.log("catchhhh");

        });
    },
    getemailInList(email, value) {
      console.log("email, value",email, value);
      
      if (!this.stapilist) return false;
      try {
        const rawData = JSON.parse(this.stapilist);
        return rawData.some((item) => item[value]?.toUpperCase() === email.toUpperCase());
      } catch (e) {
        console.error("Invalid JSON in stapilist:", e);
        return false;
      }
    },

    async getStraipList() {
      let config = {
        method: "get",
        url: `${sessapi}strapi/ekycadmin?fields[0]=data`,
        headers: {},
      };

      const axiosThis = this;
      await axios
        .request(config)
        .then((res) => {
          if (res.data?.data?.attributes?.data?.List) {
            axiosThis.stapilist = JSON.stringify(res.data.data.attributes.data.List);
            localStorage.setItem("stapilist", btoa(axiosThis.stapilist));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog() {
      this.$refs.form.reset();
      this.branchdialog = false;
    },
    exciTing() {
      if (this.empcode != null && ((this.emailids.split("@")[1] == "zebuetrade.com" && this.empcode.slice(0, 2) == "ZE") || (this.stapilist && this.getemailInList(this.emailids, "emailId") && this.getemailInList(this.empcode, "uid")))) {
        sessionStorage.setItem("sess", btoa(new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) + this.empcode));
        this.$router.push(this.board ? "/rekyc/dashboard" : "/ekyc/dashboard");
      } else {
        this.email = this.emailids;
        this.branchdialog = true;
        setTimeout(() => this.$refs.uid.$refs.input.focus(), 100);
        this.subbtn = false;
      }
    },
    suBmit() {
      if (this.$refs.form.validate() == true) {
        this.subbtn = true;
        if (this.stapilist && this.getemailInList(this.email, "emailId") && this.getemailInList(this.empcode, "uid")) {
          localStorage.setItem("empcode", this.empcode);
          localStorage.setItem("mode", this.empcode);
          sessionStorage.setItem("sess", btoa(new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) + this.empcode));
          this.$router.push(this.board ? "/rekyc/dashboard" : "/ekyc/dashboard");
          this.closeDialog();
        } else {
          let config = {
            method: "get",
            url: `https://dwld.zebuetrade.com/gen?id=${this.empcode}`,
            headers: {},
          };

          let axiosThis = this;
          axios
            .request(config)
            .then((response) => {
              if (response.data && axiosThis.email.split("@")[1] == "zebuetrade.com") {
                if (response.data.user == axiosThis.empcode && response.data.link != "Invalid" && response.data.name != null && (axiosThis.empcode.slice(0, 2) == "ZE" || axiosThis.empcode.slice(0, 2) == "IN") ) {
                  localStorage.setItem("empcode", response.data.user);
                  localStorage.setItem("mode", response.data.name);
                  sessionStorage.setItem("sess", btoa(new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) + response.data.user));
                  axiosThis.$router.push(axiosThis.board ? "/rekyc/dashboard" : "/ekyc/dashboard");
                } else {
                  axiosThis.snackbar = true;
                  axiosThis.snackbarclr = "#f23645";
                  axiosThis.snackmsgbar = "Invalid employee code";
                }
                axiosThis.closeDialog();
              } else {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#f23645";
                axiosThis.snackmsgbar = "invalid email address";
              }
              axiosThis.subbtn = false;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },

    removeData() {
      localStorage.clear();
      window.location.reload();
    },
  },
};
</script>

<style>
@import "../assets/style.css";
</style>
